import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useCallback, useRef, useEffect } from 'react';
import { getColor } from '../system';
import Text from '../Text';
import { useThemeProps } from '../system';
import { inputs, inputLabels } from './utils';

function InputLabel(_ref) {
  var controls = _ref.controls,
      state = _ref.state,
      restProps = _objectWithoutPropertiesLoose(_ref, ["controls", "state"]);

  var _useThemeProps = useThemeProps('inputLabel', restProps),
      themeProps = _extends({}, _useThemeProps);

  var input = useRef(null);

  if (controls) {
    themeProps.id = controls + "-label";
  }

  if (state) {
    themeProps.color = getColor(state);
  }

  useEffect(function () {
    input.current = inputs[controls];
    inputLabels[controls] = true;
    return function () {
      delete inputLabels[controls];
    };
  }, []);
  var focusInput = useCallback(function () {
    input.current && input.current.focus();
  }, [input]);
  var handleMouseOver = useCallback(function () {
    input.current && input.current.setState({
      isHovered: true
    });
  }, [input]);
  var handleMouseOut = useCallback(function () {
    input.current && input.current.setState({
      isHovered: false
    });
  }, [input]);
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "label",
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    onClick: focusInput
  }, themeProps));
}

InputLabel.displayName = 'Input.InputLabel';
export default InputLabel;